import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Typography, Stack } from '@mui/material';

const TextFiltrosPlanEvaluacionComponent = ({ docenteSelect }) => {
  const loginStore = Redux.useSelector((state) => state.login);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const materiasStore = Redux.useSelector((state) => state.materias);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [materia, setMateria] = React.useState(null);
  const [seccion, setSeccion] = React.useState(null);

  const idMateria = planEvaluacionStore.params.idMateria;
  const idSeccion = planEvaluacionStore.params.idSeccion;

  React.useEffect(() => {
    const fetchData = () => {
      if (docenteSelect && idMateria) {
        const materia = docenteSelect.materias.find(
          (el) => el.id === idMateria,
        );
        setMateria(materia);
      } else {
        const materia = materiasStore.all.find((el) => el.id === idMateria);
        setMateria(materia);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idMateria]);

  React.useEffect(() => {
    const fetchData = () => {
      if (docenteSelect && docenteSelect.secciones && idSeccion) {
        const seccion = docenteSelect.secciones.find(
          (el) => el.id === idSeccion,
        );
        setSeccion(seccion);
      } else {
        const seccion = seccionesStore.all.find((el) => el.id === idSeccion);
        setSeccion(seccion);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idSeccion]);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {docenteSelect && (
          <Stack direction="row" sx={{}}>
            {!loginStore.isTeacher && (
              <Typography variant="caption" color="initial" sx={{ mr: 3 }}>
                <strong>Docente:</strong>{' '}
                {docenteSelect
                  ? `${docenteSelect.usuario.perfil.pnombre} ${docenteSelect.usuario.perfil.papellido}`
                  : 'Todos'}
              </Typography>
            )}
            <Typography variant="caption" color="initial" sx={{ mr: 3 }}>
              <strong>Materia:</strong>{' '}
              {planEvaluacionStore.params.idSeccion && materia
                ? materia.nombre
                : 'Todos'}
            </Typography>
            <>
              <Typography variant="caption" color="initial" sx={{ mr: 3 }}>
                <strong>Nivel académico:</strong>{' '}
                {seccion?.nivelAcademico?.nivelAcademico.nombre ?? 'Todos'}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 3 }}>
                <strong>Sección:</strong>{' '}
                {planEvaluacionStore.params.idSeccion && seccion
                  ? seccion?.nombre
                  : 'Todos'}
              </Typography>
              <Typography variant="caption" color="initial" sx={{ mr: 3 }}>
                <strong>Turno:</strong> {seccion?.turno ?? 'Todos'}
              </Typography>
            </>
          </Stack>
        )}
      </Grid>
    </Grid>
  );
};

export default TextFiltrosPlanEvaluacionComponent;
